import { render, staticRenderFns } from "./CorrectStatistics.vue?vue&type=template&id=4acdc828&"
import script from "./CorrectStatistics.vue?vue&type=script&lang=js&"
export * from "./CorrectStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CorrectStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports